// extracted by mini-css-extract-plugin
module.exports = {"list":"Experts_list__KkjjA","item":"Experts_item__M5M1E","checkmarkIcon":"Experts_checkmark-icon__I803T"};